import { X, Minus, Plus, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { gbp } from '../lib/shop';

export default function CartDrawer() {
  const { items, drawerOpen, setDrawerOpen, setQty, remove, subtotal } = useCart();
  const navigate = useNavigate();
  if (!drawerOpen) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={() => setDrawerOpen(false)} />
      <div className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-[#FAFAF8] shadow-2xl flex flex-col">
        <div className="flex items-center justify-between p-5 border-b hairline">
          <p className="font-display font-black text-2xl uppercase">Basket</p>
          <button data-testid="cart-drawer-close" onClick={() => setDrawerOpen(false)} className="p-2"><X className="w-5 h-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {items.length === 0 && <p className="text-sm text-[#575B60] py-10 text-center">Your basket is empty.</p>}
          {items.map((it) => (
            <div key={it.key} data-testid={`cart-item-${it.key}`} className="flex gap-4 border-b hairline pb-4">
              <img src={it.image} alt="" className="w-16 h-16 object-cover bg-[#F4F4F0]" />
              <div className="flex-1 min-w-0">
                <p className="font-display font-bold uppercase tracking-wide leading-tight">{it.name}</p>
                <p className="font-mono2 text-[10px] uppercase tracking-wider text-[#8A8F95] mt-0.5">{it.strength} · {it.format}</p>
                <div className="flex items-center gap-3 mt-2">
                  <div className="flex items-center border hairline">
                    <button data-testid={`cart-minus-${it.key}`} onClick={() => setQty(it.key, it.quantity - 1)} className="p-1.5"><Minus className="w-3.5 h-3.5" /></button>
                    <span className="px-2 font-mono2 text-sm">{it.quantity}</span>
                    <button data-testid={`cart-plus-${it.key}`} onClick={() => setQty(it.key, it.quantity + 1)} className="p-1.5"><Plus className="w-3.5 h-3.5" /></button>
                  </div>
                  <button data-testid={`cart-remove-${it.key}`} onClick={() => remove(it.key)} className="p-1.5 text-[#8A8F95] hover:text-[#E54D2E]"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              <p className="font-mono2 text-sm font-semibold">{gbp(it.price * it.quantity)}</p>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="p-5 border-t hairline space-y-3">
            <div className="flex justify-between font-mono2 text-sm">
              <span className="uppercase tracking-wider text-[#575B60]">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-semibold">{gbp(subtotal)}</span>
            </div>
            <p className="text-[11px] text-[#8A8F95]">Shipping and discounts calculated at checkout.</p>
            <button data-testid="cart-checkout-button"
              onClick={() => { setDrawerOpen(false); navigate('/checkout'); }}
              className="w-full bg-[#0B0F12] text-[#FAFAF8] py-3.5 font-mono2 text-xs uppercase tracking-[0.2em] hover:bg-[#E54D2E] transition-colors">
              Checkout
            </button>
            <button data-testid="cart-view-button" onClick={() => { setDrawerOpen(false); navigate('/basket'); }}
              className="w-full border border-[#0B0F12] py-3 font-mono2 text-xs uppercase tracking-[0.2em] hover:bg-[#F4F4F0] transition-colors">
              View full basket
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
